import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { SolidIconLinkProps, SolidIconButtonState } from './solid-icon-Link';

export interface SolidIconDownloadState extends SolidIconButtonState {
    downloadStatus: number;

}
export interface DownloadProps extends SolidIconLinkProps {
    fileName: string;
}
class SolidIconDownloadLink extends React.Component<DownloadProps> {
    static contextType: Context<AppContextInterface | null> = AppContext;
    public context!: AppContextInterface;
    public state: SolidIconDownloadState = {
        hovering: false,
        downloadStatus: 0
    }

    constructor(props: DownloadProps) {
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
        this.download = this.download.bind(this);
    }

    mouseEnter() {
        this.setState({ hovering: true });
    }

    mouseLeave() {
        this.setState({ hovering: false });

    }

    async download() {
        this.setState({ downloadStatus: 1,hovering: false });

        let response = await fetch(this.props.link, { mode: 'no-cors' });
        const reader = response?.body?.getReader();
        // Step 2: get total length
        const contentLength = +response.headers.get('Content-Length')!;

        if (reader !== undefined) {
            let receivedLength = 0; // received that many bytes at the moment
            let chunks = []; // array of received binary chunks (comprises the body)
           

        // infinite loop while the body is downloading
        while (true) {
            // done is true for the last chunk
            // value is Uint8Array of the chunk bytes
            const { done, value } = await reader.read();

            if (value === undefined) {
                break;
            }

            this.setState({ downloadStatus: (receivedLength / contentLength) * 100 });
            chunks.push(value);
            receivedLength += value.length;

            if (done) {
                this.setState({ downloadStatus: 0 });
                break;
            }

            }


            let a = document.createElement("a");
            document.body.appendChild(a);
            let blob = new Blob(chunks);
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = this.props.fileName;
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            this.setState({ downloadStatus: 0 });

        }
    }

    render() {

        let buttonStyle = { backgroundColor: this.context.styles?.buttonColors.dark, color: 'white', marginRight: '0.5em' };
        let hoverStyle: any = {
            color: 'white',
            marginRight: '0.5em',
            position: 'absolute',
            transition: 'all .3s ease',
            backgroundColor: this.context.styles?.buttonColors.dark
        }
        if (this.state.hovering) {
            hoverStyle.transform = 'translateX(0%)';
            hoverStyle.opacity = '1';
        } else {
            hoverStyle.transform = 'translateX(-100%)';
            hoverStyle.opacity = '0';
        }
        let iconStyle = {
            backgroundColor: this.state.hovering || this.state.downloadStatus !== 0 ? this.context.styles?.buttonColors.vibrant : this.context.styles?.buttonColors.dark,
            ...this.props.iconStyle
        };
   
        return (
            <button onClick={this.download} className={this.props.className + " link-button"} style={{ fontSize: this.props.fontSize || '16px' }} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                <span className="link-text" style={buttonStyle}>{this.props.buttonText}</span>
                <span className="link-text" style={hoverStyle}>{this.props.hoverText || this.props.buttonText}</span>
                <span className="link-icon svg-style-container" style={iconStyle}>{this.state.downloadStatus === 0 ? this.props.icon : this.state.downloadStatus.toFixed(0) + "%"}</span> 
            </button>
        );
    }
}
  
export default SolidIconDownloadLink;
  